import React from 'react'
import PropTypes from 'prop-types'
import UserDocuments from '../../UserDocuments'
import Archived from '../../Archived'
import OwnSign from '../../OwnSign'
import Pending from '../../Pending'
import Signed from '../../Signed'
import Viewer from '../../Viewer'
import Templates from '../../Templates'

export default class ShowDocuments extends React.Component {
  static propTypes = {
    state: PropTypes.object,
    userId: PropTypes.string
  }

  render() {
    if (this.props.state.all) return <UserDocuments userId={this.props.userId} />
    if (this.props.state.pending) return <Pending userId={this.props.userId} />
    if (this.props.state.signed) return <Signed userId={this.props.userId} />
    if (this.props.state.own) return <OwnSign userId={this.props.userId} />
    if (this.props.state.viewer) return <Viewer userId={this.props.userId} />
    if (this.props.state.archi) return <Archived userId={this.props.userId} />
    if (this.props.state.temp) return <Templates userId={this.props.userId} />
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Admin/UserInformation/Layout/ShowDocuments/index.js